<template>
  <div class="emsImg">
    <img
      v-viewer
      :src="sorce"
      alt=""
    >
  </div>
</template>

<script>
import { getCookie } from '../../util/util'
export default {
  props: {
    // 可以是一个完整的api+imageID
    src: {
      type: String,
      default: 'a/api/ossImage/downloadByImageId?imageId='
    },
    imageId: {
      type: String,
      default: ''
    },
    ossSrc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      noImgSrc: `${this.api}a/api/image/download?dataId=32404&isThumball=true&type=CHECK_DRAWINGS_EXAMPLE`,
      sorce: '',
      img: null,
      token: `&JSESSIONID=${getCookie('JSESSIONID')}&__ajax=${true}&mobileLogin=${false}`
    }
  },
  watch: {
    src() {
      this.setSorce()
    },
    ossSrc() {
      this.setSorce()
    },
    imageId() {
      this.setSorce()
    }
  },
  created() {
    this.setSorce()
  },
  methods: {
    loadImg() {
      const self = this
      this.img = new Image()
      this.img.src = this.sorce
      this.img.onload = () => {

      }
      this.img.onerror = () => {
        self.sorce = self.noImgSrc
      }
    },
    setSorce() {
      if (this.ossSrc.length > 0) {
        this.sorce = this.ossSrc
      } else {
        this.sorce = this.api + this.src + this.imageId + this.token
      }
      this.loadImg()
    }
  }
}
</script>

<style lang="less" scoped>
.emsImg {
  display: inline-block;
  img {
    width: inherit;
    height: inherit;
  }
}
</style>




// WEBPACK FOOTER //
// src/component/base/emsImg.vue